import { applySnapshot, isValidReference } from 'mobx-state-tree';

export function applySnapshotAsync(target: Parameters<typeof applySnapshot>[0], snapshot: Parameters<typeof applySnapshot>[1]): void {
  if (isValidReference(() => target, true)) {
    applySnapshot(target, snapshot);
  }
}
